import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import { useEffect, useState } from 'react'
import ArticlePreview from '../components/ArticlePreview'
import BSCard from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Card from '../components/Card'
import CardHover from '../components/CardHover'
import ContentPreview from '../components/ContentPreview'
import { Helmet } from 'react-helmet'
import { OutboundLink } from 'react-ga'
import PleaseSupportUs from '../components/PleaseSupportUs'
import Skeleton from 'react-loading-skeleton'
import Spinner from '../components/Spinner'
import classNames from 'classnames'
import { initialize } from '../store/pagedata'
import styles from '../styles/index.module.scss'
import useDarkMode from 'use-dark-mode'
import { useDispatch } from 'react-redux'
import { v4 } from 'uuid'

const Index = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const [articlesPage, setArticlesPage] = useState(0)
  const [articles, setArticles] = useState([])
  const [contentPage, setContentPage] = useState(0)
  const [content, setContent] = useState([])
  const [dailyCommander, setDailyCommander] = useState()
  const [isLoadingMoreArticles, setIsLoadingMoreArticles] = useState(false)
  const [isLoadingMoreContent, setIsLoadingMoreContent] = useState(false)

  useEffect(async () => {
    const fetchDaily = async () => {
      const res = await fetch('https://json.edhrec.com/static/daily')
      return await res.json()
    }

    const fetchWordpress = async () => {
      const res = await fetch('https://json.edhrec.com/static/wordpress')
      return await res.json()
    }

    const [daily, wordpress] = await Promise.all([
      fetchDaily(),
      fetchWordpress(),
    ])

    setDailyCommander(daily)
    setArticles(wordpress.articles)
    setContent(wordpress.content)

    dispatch(initialize())
  }, [])

  const fetchMoreArticles = async () => {
    setIsLoadingMoreArticles(true)
    const res = await fetch(
      `https://json.edhrec.com/static/wordpress/articles/${articlesPage + 1}`
    )
    const json = await res.json()
    setArticlesPage(articlesPage + 1)
    setArticles([...articles, ...json])
    setIsLoadingMoreArticles(false)
  }

  const fetchMoreContent = async () => {
    setIsLoadingMoreContent(true)
    const res = await fetch(
      `https://json.edhrec.com/static/wordpress/content/${contentPage + 1}`
    )
    const json = await res.json()
    setContentPage(contentPage + 1)
    setContent([...content, ...json])
    setIsLoadingMoreContent(false)
  }

  const isLoading = articles.length === 0

  return (
    <>
      <Helmet>
        <meta
          name='description'
          content='EDH Recommendations and strategy content for Magic: the Gathering Commander'
        />
        <meta
          name='keywords'
          content='EDHREC,EDH,recommendations,Commander,MTG,Magic,staples,strategy,content'
        />
        <title>EDHREC</title>
      </Helmet>
      <div className={styles.container}>
        <div
          className={classNames(styles.containerLeft, {
            [styles.dark]: darkMode.value,
          })}
        >
          {isLoading ? (
            <>
              {[...Array(3)].map(() => (
                <div className={classNames(styles.grid, styles.row)} key={v4()}>
                  <div className={styles.rowItem}>
                    <ArticlePreview isLoading />
                  </div>
                  <div className={styles.rowItem}>
                    <ArticlePreview isLoading />
                  </div>
                </div>
              ))}
            </>
          ) : (
            articles
              ?.slice(0, -1)
              .reduce((res, _, i, arr) => {
                if (i % 2 === 0) res.push(arr.slice(i, i + 2))
                return res
              }, [])
              .map((articleRow) => (
                <div
                  key={articleRow.map((article) => article.link).join()}
                  className={classNames(styles.grid, styles.row)}
                >
                  {articleRow.map((article) => (
                    <div key={article.link} className={styles.rowItem}>
                      <ArticlePreview {...article} />
                    </div>
                  ))}
                </div>
              ))
          )}
          {!isLoading && (
            <>
              <div className={styles.row}>
                <span className={styles.loadMore}>
                  <Button onClick={fetchMoreArticles} variant='link'>
                    {isLoadingMoreArticles ? <Spinner /> : 'Load More Articles'}
                  </Button>
                </span>
              </div>
              <div className={styles.row}>
                <div className={styles.rowItem}>
                  <h2>
                    <OutboundLink
                      alt='Community Content'
                      eventLabel='https://articles.edhrec.com/author/contentadmin/'
                      rel='noreferrer'
                      target='_blank'
                      to='https://articles.edhrec.com/author/contentadmin/'
                    >
                      Community Content
                    </OutboundLink>
                  </h2>
                </div>
              </div>
              {content
                ?.reduce((res, _, i, arr) => {
                  if (i % 2 === 0) res.push(arr.slice(i, i + 2))
                  return res
                }, [])
                .map((contentRow) => (
                  <div
                    key={contentRow.map((content) => content.link).join()}
                    className={classNames(styles.grid, styles.row)}
                  >
                    {contentRow.map((content) => (
                      <div key={content.link} className={styles.rowItem}>
                        <ContentPreview {...content} />
                      </div>
                    ))}
                  </div>
                ))}
              <div className={styles.row}>
                <span className={styles.loadMore}>
                  <Button onClick={fetchMoreContent} variant='link'>
                    {isLoadingMoreContent ? (
                      <Spinner />
                    ) : (
                      'Load More Community Content'
                    )}
                  </Button>
                </span>
              </div>
            </>
          )}
          <div className={styles.loadMore}>
            <div className='text-center'>
              <span data-ccpa-link='1'></span>
            </div>
          </div>
        </div>
        <div
          className={classNames(styles.containerRight, {
            [styles.dark]: darkMode.value,
          })}
        >
          <div className={styles.row}>
            <div className={styles.rowItem}>
              <div className={styles.rowContent}>
                <h5 className='title'>Commander of the Day</h5>
                <div className={styles.dailyCommander}>
                  <Card hideLabel hideName {...dailyCommander?.daily} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowItem}>
              <h5 className='title'>Top Commanders Weekly</h5>
              <BSCard className={classNames(styles.rowContent, 'shadow-sm')}>
                <BSCard.Body>
                  <ul>
                    {isLoading ? (
                      <Skeleton count={10} />
                    ) : (
                      dailyCommander?.weekly.map((item, i) => (
                        <li key={v4()}>
                          {i + 1}. <CardHover {...item} left />
                        </li>
                      ))
                    )}
                  </ul>
                </BSCard.Body>
              </BSCard>
            </div>
          </div>
          {dailyCommander?.trending && (
            <div className={styles.row}>
              <div className={styles.rowItem}>
                <h5 className='title'>Trending Cards</h5>
                <BSCard className={classNames(styles.rowContent, 'shadow-sm')}>
                  <BSCard.Body>
                    <ul>
                      {isLoading ? (
                        <Skeleton count={10} />
                      ) : (
                        dailyCommander.trending.map((item, i) => (
                          <li key={v4()}>
                            {i + 1}. <CardHover {...item} left />
                          </li>
                        ))
                      )}
                    </ul>
                  </BSCard.Body>
                </BSCard>
              </div>
            </div>
          )}
          <div className='mvHomeSidebar'>
            <PleaseSupportUs />
          </div>
        </div>
      </div>
    </>
  )
}

export default Index
